import { render, staticRenderFns } from "./digipayReport.vue?vue&type=template&id=a135b468&"
import script from "./digipayReport.vue?vue&type=script&lang=js&"
export * from "./digipayReport.vue?vue&type=script&lang=js&"
import style0 from "./digipayReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports